import React, { ReactNode } from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/free-solid-svg-icons'

type Props = {
    url?: string,
    title?: string,
    rightText?: string | ReactNode,
    onClick ?: () => void,
    bottomText?: string | ReactNode,
    rightStyle ?: React.CSSProperties
}

const Attachment = ({ url, onClick, title, rightText, bottomText, rightStyle = {} } : Props) => (
  <div className="p-10 d-flex row justify-space align-center w-100">
    <div className="d-flex flex-col">
      <GHref href={onClick ? undefined : url} onClick={onClick} target="_blank">
        <FontAwesomeIcon icon={faLink} className="mr-4" />
        {title}
      </GHref>
      {bottomText && (
        <span className="mb-16 text-12 italic">
          {bottomText}
        </span>
      )}
    </div>
    <span
      style={{
        color: '#837575',
        fontSize: 12,
        ...rightStyle
      }}
    >
      &nbsp;
      {rightText}
    </span>
  </div>
)

export default Attachment
